import type { SxProps, Theme } from '@mui/material';

import { TASK_LIST_WIDTH } from 'components/shared/TaskList/TaskList';

export const getScrollWrapperSx = (
  taskListIsOpen: boolean
): SxProps<Theme> => ({
  width: '100%',
  overflowX: 'scroll',
  height: '100%',
  minWidth: taskListIsOpen ? 'initial' : '100%',
  maxWidth: taskListIsOpen ? `calc(100% - ${TASK_LIST_WIDTH}px)` : 'initial',
  position: 'relative',
  pb: '15px'
});

export const getScrollContainerSx = (isTablet: boolean): SxProps<Theme> => ({
  overflowX: 'auto',
  scrollbarWidth: 'none',
  height: `calc(100vh - ${isTablet ? 260 : 210}px)`
});

export const stickySummarySx: SxProps<Theme> = {
  position: 'sticky',
  left: 0,
  zIndex: 20,
  display: 'flex',
  alignItems: 'center',
  minHeight: '65px',
  margin: '-5px 0',
  background: `linear-gradient(90deg, var(--mui-palette-background-default) 80%, transparent)`
};
